import React, { FC } from 'react';
import { Row } from 'antd';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import {
  H8CamptonSemiBold20,
  SmallGrey12,
  GreenLinkText,
  ContentSmallCamptonBook
} from '../../../../layout/globalFonts';
import { ProductInfo } from '../../../../swagger/api';
import ContentStore from '../../../../stores/ContentStore';
import { ReactComponent as MastercardLogo } from '../../../../layout/icons/payment-mastercard-logo.svg';
import { ReactComponent as VisaLogo } from '../../../../layout/icons/payment-visa-icon.svg';
import { ReactComponent as DankortLogo } from '../../../../layout/icons/payment-dankort-logo.svg';
import RouteUrlPaths from '../../../../RouteUrlPaths';
import maskCardNumber from '../../../../utils/maskCardNumberPrivate';

const HeaderSection = styled(Row)`
  padding-bottom: 12px;
`;

const CardTypeRow = styled.div`
  margin-bottom: 10px;
`;

const CardNumberRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const StyledGreenLinkText = styled(GreenLinkText)`
  margin-top: auto;
  cursor: pointer;
`;

interface PrivatePaymentProps {
  product: ProductInfo;
  contentStore: ContentStore;
}

const PrivatePayment: FC<PrivatePaymentProps> = (props) => {
  const { product, contentStore } = props;
  const navigate = useNavigate();

  const getCardLogo = (cardType?: string) => {
    const type = cardType?.toLowerCase();
    if (type?.includes('visa')) {
      return <VisaLogo />;
    }
    if (type?.includes('dankort') || type?.includes('dk')) {
      return <DankortLogo />;
    }
    return <MastercardLogo />;
  };

  const goToPaymentCard = () => {
    navigate(`/${RouteUrlPaths.PaymentCard}`);
  };

  if (!product.paymentMethod) {
    return null;
  }

  return (
    <StyledContainer>
      <HeaderSection>
        <H8CamptonSemiBold20>
          {contentStore.cmsStore.getContent('LinkedPaymentMethod')?.content}
        </H8CamptonSemiBold20>
      </HeaderSection>

      <CardTypeRow>
        <SmallGrey12>
          {contentStore.cmsStore.getContent(product.paymentMethod.cardType!)?.content}
        </SmallGrey12>
      </CardTypeRow>

      <CardNumberRow>
        {getCardLogo(product.paymentMethod.cardType)}
        <ContentSmallCamptonBook>
          {maskCardNumber(product.paymentMethod.cardNumber!)}
        </ContentSmallCamptonBook>
      </CardNumberRow>

      <StyledGreenLinkText onClick={goToPaymentCard}>
        {contentStore.cmsStore.getContent('LinkedPaymentMethod')?.subText}
      </StyledGreenLinkText>
    </StyledContainer>
  );
};

export default PrivatePayment;
